'use strict';

var link = {};

exports.__exports = link;
//# sourceMappingURL=link.cjs.map
